import svg_01 from "./v1.svg";
import svg_02 from "./v2.svg";
import svg_03 from "./v3.svg";
import svg_04 from "./v4.svg";
import svg_05 from "./v5.svg";
import svg_06 from "./v6.svg";
import svg_07 from "./v7.svg";
import svg_08 from "./v8.svg";
import svg_09 from "./v9.svg";
import svg_10 from "./v10.svg";
import svg_11 from "./v11.svg";
import svg_12 from "./v12.svg";
import svg_13 from "./v13.svg";

export enum Patterns {
  Pattern01 = "Pattern01",
  Pattern02 = "Pattern02",
  Pattern03 = "Pattern03",
  Pattern04 = "Pattern04",
  Pattern05 = "Pattern05",
  Pattern06 = "Pattern06",
  Pattern07 = "Pattern07",
  Pattern08 = "Pattern08",
  Pattern09 = "Pattern09",
  Pattern10 = "Pattern10",
  Pattern11 = "Pattern11",
  Pattern12 = "Pattern12",
  Pattern13 = "Pattern13",
}

const PATTERNS = {
  [Patterns.Pattern01]: svg_01,
  [Patterns.Pattern02]: svg_02,
  [Patterns.Pattern03]: svg_03,
  [Patterns.Pattern04]: svg_04,
  [Patterns.Pattern05]: svg_05,
  [Patterns.Pattern06]: svg_06,
  [Patterns.Pattern07]: svg_07,
  [Patterns.Pattern08]: svg_08,
  [Patterns.Pattern09]: svg_09,
  [Patterns.Pattern10]: svg_10,
  [Patterns.Pattern11]: svg_11,
  [Patterns.Pattern12]: svg_12,
  [Patterns.Pattern13]: svg_13,
} as const;

export function isPattern(pattern: Patterns | unknown): pattern is Patterns {
  return Boolean(PATTERNS[pattern as Patterns]);
}

export function svgImage(pattern = Patterns.Pattern01): {
  src: string;
  width: number;
  height: number;
} {
  return PATTERNS[pattern] || PATTERNS[Patterns.Pattern01];
}
